function validateURL(url, channelType) {
  var pattern =
    /(\b(https?|http):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  if (channelType === 'slack') {
    pattern = /https:\/\/[a-zA-Z0-9_-]+.slack\.com\/[a-zA-Z0-9_-]+/;
  }
  if (pattern.test(url)) {
    return true;
  }
  return false;
}
function validateEmail(email) {
  var validRegex =
    '^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$';
  return String(email).toLowerCase().match(validRegex);
}

function validateText(field) {
  return /^( )?[a-zA-Z0-9]+( [a-zA-Z0-9]+)*( )?$/.test(field);
}

function validateFirstName(field) {
  return /^([A-Za-z]([-']?[A-Za-z]+)*\s*)+$/.test(field);
}
function validateAlias(field) {
  return /^( )?[a-zA-Z0-9-]+( [a-zA-Z0-9-]+)*( )?$/.test(field);
}

function validateRoleName(name) {
  return /^[a-zA-Z]([a-zA-Z0-9\s._-])*$/.test(name);
}

export {
  validateURL,
  validateEmail,
  validateText,
  validateAlias,
  validateFirstName,
  validateRoleName,
};
